paymentMethodsService.$inject = ['$http', '$q', 'APP_CONFIG'];
function paymentMethodsService($http, $q, APP_CONFIG) {
  let service = {
    fetch(itineraryId) {
      return $q((resolve, reject) => {
        service.paymentMethodsLoading = true;
        $http
          .get(APP_CONFIG.api.root + `api/Itinerary/${itineraryId}/PaymentMethod`, {})
          .success((data) => {
            service.paymentMethods = data;
            service.paymentMethodsLoading = false;
            resolve(data);
          })
          .error(() => {
            service.paymentMethodsLoading = false;
            reject();
          });
      });
    },
    fetchExpiringHotelPaymentMethods(itineraryId) {
      return $q((resolve, reject) => {
        $http
          .get(APP_CONFIG.api.root + `api/Itinerary/${itineraryId}/ExpiringHotelPaymentMethods`, {})
          .success((data) => {
            data.forEach((paymentMethod) => {
              paymentMethod.Payment.Last4Digits = paymentMethod.Payment.Number.substring(paymentMethod.Payment.Number.length - 4);
            });

            service.paymentMethods = data;
            resolve(data);
          })
          .error(() => {
            reject();
          });
      });
    },
    addPaymentMethod(newPaymentMethod, groupIds) {
      const newPaymentObj = {
        Payment: {
          ExpiryMonth: newPaymentMethod.cardExpiryMonth,
          ExpiryYear: newPaymentMethod.cardExpiryYear,
          Holder: newPaymentMethod.cardHolder,
          Number: newPaymentMethod.cardNumber,
          PaymentType: 'Card',
          Reference: null,
          SecurityCode: null,
          SecurityCodeRequired: true,
          Type: {
            Code: newPaymentMethod.Card.Type.Code,
            Value: newPaymentMethod.Card.Type.Code,
          },
        },
        SectorGroups: groupIds,
        MandatorySectorGroups: [],
      };

      service.paymentMethods.push(newPaymentObj);
      return newPaymentObj;
    },
    populateEachPaxWithSelectedPaymentMethods(paymentMethods, travellers) {
      let paymentMissing = 0;

      _.forEach(travellers, (pax, paxIndex) => {
        const paymentsCopy = angular.copy(pax.Configurations.PaymentMethod.PaymentItems);
        pax.Configurations.PaymentMethod.PaymentItems = [];

        _.forEach(pax.Flights, (flight) => {
          if (checkSectorStatusNoPayment(flight)) {
            return;
          }
          if (paymentMethods.allPax && paymentMethods.allPax.flights) {
            pax.Configurations.PaymentMethod.PaymentItems.push(
              buildPaymentObj(paymentMethods.allPax.flights.Payment, flight.GroupIdentifier, 'Flight')
            );
          } else if (paymentMethods[paxIndex + 2] && paymentMethods[paxIndex + 2].flights[flight.GroupIdentifier]) {
            if (!paymentMethods[paxIndex + 2].flights[flight.GroupIdentifier].Payment) {
              const foundPayment = findPaymentWithTypeAndGrpId(paymentsCopy, 'Flight', flight.GroupIdentifier);

              if (foundPayment.Card) {
                paymentMethods[paxIndex + 2].flights[flight.GroupIdentifier].Payment = foundPayment.Card;
              } else {
                paymentMethods[paxIndex + 2].flights[flight.GroupIdentifier].Payment = foundPayment.Invoice;
              }
            }

            pax.Configurations.PaymentMethod.PaymentItems.push(
              buildPaymentObj(paymentMethods[paxIndex + 2].flights[flight.GroupIdentifier].Payment, flight.GroupIdentifier, 'Flight')
            );
          } else {
            paymentMissing += 1;
          }
        });

        //Ancillaries
        _.forEach(pax.Flights, (flight) => {
          if (!(flight.AncillaryServices && flight.AncillaryServices.length > 0)) return;
          _.forEach(flight.AncillaryServices, (ancillary) => {
            if (!(ancillary.QuantitySelected > 0) || ancillary.BookingStatus === 'Booked') {
              return;
            }
            if (paymentMethods.allPax && paymentMethods.allPax.ancillaries) {
              pax.Configurations.PaymentMethod.PaymentItems.push(
                buildPaymentObj(paymentMethods.allPax.ancillaries.Payment, ancillary.Identifier, 'Ancillary')
              );
            } else if (paymentMethods[paxIndex + 2] && paymentMethods[paxIndex + 2].ancillaries[ancillary.Identifier]) {
              if (!paymentMethods[paxIndex + 2].ancillaries[ancillary.Identifier].Payment) {
                const foundPayment = findPaymentWithTypeAndGrpId(paymentsCopy, 'Ancillary', ancillary.Identifier);

                if (foundPayment.Card) {
                  paymentMethods[paxIndex + 2].ancillaries[ancillary.Identifier].Payment = foundPayment.Card;
                } else {
                  paymentMethods[paxIndex + 2].ancillaries[ancillary.Identifier].Payment = foundPayment.Invoice;
                }
              }

              pax.Configurations.PaymentMethod.PaymentItems.push(
                buildPaymentObj(paymentMethods[paxIndex + 2].ancillaries[ancillary.Identifier].Payment, ancillary.Identifier, 'Ancillary')
              );
            } else {
              paymentMissing += 1;
            }
          });
        });

        _.forEach(pax.Rails, (rail) => {
          if (checkSectorStatusNoPayment(rail)) {
            return;
          }
          if (paymentMethods.allPax && paymentMethods.allPax.rails) {
            pax.Configurations.PaymentMethod.PaymentItems.push(
              buildPaymentObj(paymentMethods.allPax.rails.Payment, rail.GroupIdentifier, 'Rail')
            );
          } else if (paymentMethods[paxIndex + 2] && paymentMethods[paxIndex + 2].rails[rail.GroupIdentifier]) {
            if (!paymentMethods[paxIndex + 2].rails[rail.GroupIdentifier].Payment) {
              const foundPayment = findPaymentWithTypeAndGrpId(paymentsCopy, 'Rail', rail.GroupIdentifier);

              if (foundPayment.Card) {
                paymentMethods[paxIndex + 2].rails[rail.GroupIdentifier].Payment = foundPayment.Card;
              } else {
                paymentMethods[paxIndex + 2].rails[rail.GroupIdentifier].Payment = foundPayment.Invoice;
              }
            }

            pax.Configurations.PaymentMethod.PaymentItems.push(
              buildPaymentObj(paymentMethods[paxIndex + 2].rails[rail.GroupIdentifier].Payment, rail.GroupIdentifier, 'Rail')
            );
          } else {
            paymentMissing += 1;
          }
        });

        _.forEach(pax.Hotels, (hotel) => {
          if (checkSectorStatusNoPayment(hotel)) {
            return;
          }
          if (paymentMethods.allPax && paymentMethods.allPax.hotels) {
            pax.Configurations.PaymentMethod.PaymentItems.push(
              buildPaymentObj(paymentMethods.allPax.hotels.Payment, hotel.GroupIdentifier, 'Hotel')
            );
          } else if (paymentMethods[paxIndex + 2] && paymentMethods[paxIndex + 2].hotels[hotel.GroupIdentifier]) {
            if (!paymentMethods[paxIndex + 2].hotels[hotel.GroupIdentifier].Payment) {
              const foundPayment = findPaymentWithTypeAndGrpId(paymentsCopy, 'Hotel', hotel.GroupIdentifier);

              if (foundPayment.Card) {
                paymentMethods[paxIndex + 2].hotels[hotel.GroupIdentifier].Payment = foundPayment.Card;
              } else {
                paymentMethods[paxIndex + 2].hotels[hotel.GroupIdentifier].Payment = foundPayment.Invoice;
              }
            }

            pax.Configurations.PaymentMethod.PaymentItems.push(
              buildPaymentObj(paymentMethods[paxIndex + 2].hotels[hotel.GroupIdentifier].Payment, hotel.GroupIdentifier, 'Hotel')
            );
          } else {
            paymentMissing += 1;
          }
        });

        _.forEach(pax.Cars, (car) => {
          if (checkSectorStatusNoPayment(car)) {
            return;
          }
          if (paymentMethods.allPax && paymentMethods.allPax.cars) {
            pax.Configurations.PaymentMethod.PaymentItems.push(
              buildPaymentObj(paymentMethods.allPax.cars.Payment, car.GroupIdentifier, 'Car')
            );
          } else if (paymentMethods[paxIndex + 2] && paymentMethods[paxIndex + 2].cars[car.GroupIdentifier]) {
            if (!paymentMethods[paxIndex + 2].cars[car.GroupIdentifier].Payment) {
              const foundPayment = findPaymentWithTypeAndGrpId(paymentsCopy, 'Car', car.GroupIdentifier);

              if (foundPayment.Card) {
                paymentMethods[paxIndex + 2].cars[car.GroupIdentifier].Payment = foundPayment.Card;
              } else {
                paymentMethods[paxIndex + 2].cars[car.GroupIdentifier].Payment = foundPayment.Invoice;
              }
            }

            pax.Configurations.PaymentMethod.PaymentItems.push(
              buildPaymentObj(paymentMethods[paxIndex + 2].cars[car.GroupIdentifier].Payment, car.GroupIdentifier, 'Car')
            );
          } else {
            paymentMissing += 1;
          }
        });

        ///Ground Transports
        _.forEach(pax.GroundTransports, (ground) => {
          if (checkSectorStatusNoPayment(ground)) {
            return;
          }
          if (paymentMethods.allPax && paymentMethods.allPax.grounds) {
            pax.Configurations.PaymentMethod.PaymentItems.push(
              buildPaymentObj(paymentMethods.allPax.grounds.Payment, ground.GroupIdentifier, 'GroundTransport')
            );
          } else if (paymentMethods[paxIndex + 2] && paymentMethods[paxIndex + 2].grounds[ground.GroupIdentifier]) {
            if (!paymentMethods[paxIndex + 2].grounds[ground.GroupIdentifier].Payment) {
              const foundPayment = findPaymentWithTypeAndGrpId(paymentsCopy, 'GroundTransport', ground.GroupIdentifier);

              if (foundPayment.Card) {
                paymentMethods[paxIndex + 2].grounds[ground.GroupIdentifier].Payment = foundPayment.Card;
              } else {
                paymentMethods[paxIndex + 2].grounds[ground.GroupIdentifier].Payment = foundPayment.Invoice;
              }
            }

            pax.Configurations.PaymentMethod.PaymentItems.push(
              buildPaymentObj(
                paymentMethods[paxIndex + 2].grounds[ground.GroupIdentifier].Payment,
                ground.GroupIdentifier,
                'GroundTransport'
              )
            );
          } else {
            paymentMissing += 1;
          }
        });

        //EndGroundTransports
      });

      return {
        travellers: travellers,
        missingPayments: paymentMissing > 0,
      };
    },
    checkAllPaxPaymentsSelected(pax) {
      if (!pax) {
        return;
      }
      let eachSectorHasPayment = true;
      let sectorGrpIds = [];

      _.forEach(pax.Flights, (flight) => {
        if (checkSectorStatusNoPayment(flight)) {
          return;
        }
        sectorGrpIds.push(flight.GroupIdentifier);
      });

      _.forEach(pax.Flights, (flight) => {
        _.forEach(flight.AncillaryServices, (ancillary) => {
          if (ancillary.BookingStatus === 'Booked' || ancillary.BookingStatus > 1 || ancillary.QuantitySelected == 0) {
            return;
          }
          sectorGrpIds.push(ancillary.Identifier);
        });
      });

      _.forEach(pax.Rails, (rail) => {
        if (checkSectorStatusNoPayment(rail)) {
          return;
        }
        sectorGrpIds.push(rail.GroupIdentifier);
      });

      _.forEach(pax.Hotels, (hotel) => {
        if (checkSectorStatusNoPayment(hotel)) {
          return;
        }
        sectorGrpIds.push(hotel.GroupIdentifier);
      });

      _.forEach(pax.Cars, (car) => {
        if (checkSectorStatusNoPayment(car)) {
          return;
        }
        sectorGrpIds.push(car.GroupIdentifier);
      });

      _.forEach(pax.GroundTransports, (ground) => {
        if (checkSectorStatusNoPayment(ground)) {
          return;
        }
        sectorGrpIds.push(ground.GroupIdentifier);
      });

      sectorGrpIds = _.uniq(sectorGrpIds);

      sectorGrpIds.every((grpId) => {
        if (eachSectorHasPayment) {
          const findMatch = _.find(pax.Configurations.PaymentMethod.PaymentItems, (PaymentItem) => {
            return PaymentItem.SectorGroupIdentifier === grpId;
          });

          eachSectorHasPayment = !!findMatch;
        }

        return eachSectorHasPayment;
      });

      return eachSectorHasPayment;
    },
    purgeDuplicatePaymentMethods(payments) {
      const grpIds = [];

      return _.filter(payments, (payment) => {
        let groupId = payment.SectorGroupIdentifier;
        if (payment.SectorIdentifier) {
          groupId = payment.SectorIdentifier;
        }
        if (grpIds.indexOf(groupId) === -1) {
          grpIds.push(groupId);
          return true;
        } else {
          return false;
        }
      });
    },
    checkForCVV(PaymentItems, cvvObj) {
      let allCVVsPresent = true;

      PaymentItems.every((payment) => {
        if (allCVVsPresent && payment.Card && payment.Card.SecurityCodeRequired && payment.Type !== 'Seat') {
          allCVVsPresent = cvvObj[payment.Card.Reference];
        }

        return allCVVsPresent;
      });

      return allCVVsPresent;
    },
    addCVVsToPayments(paymentItems, cvvObj) {
      return _.forEach(paymentItems, (payment) => {
        if (payment.Card && payment.Card.SecurityCodeRequired) {
          payment.Card.SecurityCode = cvvObj[payment.Card.Reference];
        }
      });
    },
    checkSectorStatusNoPayment(sector) {
      return checkSectorStatusNoPayment(sector);
    },
    updatedPaxWithPayments: undefined,
    paymentMethods: [],
    paymentMethodsLoading: false,
  };
  function checkSectorStatusNoPayment(sector) {
    let checkStatus = !(
      sector &&
      sector.Status &&
      sector.Status != 'CurrentItin' &&
      sector.Status != 'CurrentItinCancel' &&
      sector.Status != 'CurrentItinNotCancellable'
    );

    return checkStatus;
  }
  function buildPaymentObj(Payment, grpId, type) {
    let paymentObj = {};

    if (Payment.PaymentType === 'Invoice') {
      paymentObj = {
        Card: null,
        Invoice: {
          PaymentType: 'Invoice',
          Reference: 'Invoice',
        },
        SectorGroupIdentifier: grpId,
        Type: type,
      };
    } else {
      paymentObj = {
        Card: Payment,
        Invoice: null,
        SectorGroupIdentifier: grpId,
        Type: type,
      };
    }

    return paymentObj;
  }

  function findPaymentWithTypeAndGrpId(payments, type, grpId) {
    return _.find(payments, (payment) => {
      return payment.SectorGroupIdentifier === grpId && payment.Type === type;
    });
  }

  return service;
}

export default paymentMethodsService;



// WEBPACK FOOTER //
// ./src/services/paymentMethodsService.js